/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Layer, Box, Anchor, Button, Heading, Input, CheckBox, Text, Spinner } from 'wt-ui';
import { Close, Calendar, MailOption } from 'grommet-icons';

import API from '../../services/API';

const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const AlertLayer = ({ event, ...rest }) => {
  const [investorType, setInvestorType] = useState(null);
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const onSubmit = (e) => {
    // console.log('click', email, investorType);
    if (email === '' || !validateEmail(email) || !investorType) {
      setError(true);
      return;
    }
    setError(false);
    setLoading(true)
    API.createAlertMe({
      email,
      investorType,
      event,
    }); // */
    setLoading(false);
    setSuccess(true);
  };

  return (
    <Layer {...rest}>
      <Box background="transparent" pad="medium" width="600px" gap="medium">
        <Anchor href="#" onClick={rest.onEsc} style={{ position: 'absolute', right: '10px', top: '10px' }}>
          <Close />
        </Anchor>
        <Box background="transparent">
          <Heading level={3} style={{ margin: '0px' }} textAlign="center">
            Notification feature available soon...
          </Heading>
        </Box>
        <Box background="transparent" direction="row" gap="small" justify="center">
          <Button type="submit" onClick={rest.onEsc} primary>
            Close
          </Button>
        </Box>
      </Box>
    </Layer>
  );//*/

  let content = (<Box background="transparent" gap="medium">
    <Box background="transparent">
      <Heading secondary level={2} style={{ marginTop: '0px' }}>
        Create an email alert
    </Heading>
      <Box background="transparent" direction="row" gap="small">
        <Calendar />
        <Heading level={3} style={{ margin: '0px' }}>
          {event.enum ? event.enum.displayName || event.enum.name : event.displayName || event.name}
        </Heading>
      </Box>

    </Box>
    <Box background="transparent">
      <Input
        placeholder="Your Email"
        onChange={(e) => {
          setEmail(e.target.value);
        }}
      />
    </Box>
    {error ? <Text color="#d32323">Please enter a valid email and select investor type below.</Text> : ''}
    <Box background="transparent" direction="row" gap="small">
      <CheckBox
        checked={investorType === 'individual'}
        onChange={() => setInvestorType('individual')}
        label="Individual Investror"
      />
      <CheckBox
        checked={investorType === 'institutional'}
        onChange={() => setInvestorType('institutional')}
        label="Institutional Investor"
      />
      <Button type="submit" onClick={onSubmit} primary>
        Submit
      </Button>
    </Box>
  </Box>);

  if (loading) {
    content = (
      <Box background="transparent" align="center">
        <Spinner primary />
      </Box>
    );
  }

  if (success) {
    content = (
      <Box background="transparent" align="center">
        <MailOption size="medium" />
        <Heading level={3} style={{marginTop: '0px'}}>Alert created!</Heading>
        <Text>We have sent you an email with further instructions.</Text>
      </Box>
    );
  }


  return (
    <Layer {...rest}>
      <Box background="transparent" pad="medium" width="650px">
        <Anchor href="#" onClick={rest.onEsc} style={{ position: 'absolute', right: '10px', top: '10px' }}>
          <Close />
        </Anchor>
        {content}      
      </Box>
    </Layer>
  ); // */
};
AlertLayer.propTypes = {
  event: PropTypes.shape({}).isRequired,
};

export default AlertLayer;
